module.exports = __webpack_public_path__ + "9637c14ab86cab09f8b031892fa8f548.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/thumbnail/public/history/1.jpg
// module id = 506
// module chunks = 0